import { PaletteOptions } from "@mui/material";

export const palette: PaletteOptions = {
    action: {
        disabledBackground: undefined,
        disabled: undefined,
        selected: "rgba(255, 255, 255, 0.16)",
    },
    text: {
        primary: "#ffffff",
    },
    background: {
        default: "#0e0d0d",
        paper: "#121212",
    },
    common: {
        black: "#000",
        white: "#fff",
    },
    primary: {
        main: "#FF9E00",
        contrastText: "#000",
    },
    secondary: {
        main: "#c4c4c4",
        contrastText: "#000",
    },
    error: {
        main: "#FF2A20",
        light: "#FF2A20",
    },
    success: {
        main: "#2ED47A",
    },
    info: {
        main: '#0097BF'
    },
    grey: {
        "50": "#C4C4C4",
        "100": "#999999",
        "200": "#8f8f8f",
        "300": "#A9B3B7",
        "400": "#282828",
        "500": "#929292",
        "600": "#3E3E3E",
        "700": "#1B1C1C",
        "800": "#0E0D0D",
    },
};
